import React from "react";

import { Link } from "react-router-dom";

import Table from "../../common/Table";
import RowPhoto from "../../common/TdImg";

const SectionSalaryList = ({ data, query }) => {
  const renderLink = (e) => {
    return (
      <Link
        to={`/mis/staff/${e.staff_id}/profile/salary?staffName=${e.staff_name}`}
      >
        {e.staff_name}
      </Link>
    );
  };

  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "staff_photo",
      label: "عکس",
      content: ({ staff_photo }) => <RowPhoto src={staff_photo} />,
    },
    {
      path: "aria_id",
      label: "کد کارمند",
    },
    {
      path: "staff_name",
      label: "کارمند",
      content: (e) => renderLink(e),
    },
    {
      path: "position",
      label: "وظیفه",
    },
    {
      path: "payable",
      label: "قابل پرداخت",
    },
    {
      path: "paid",
      label: "پرداخت شده",
    },
    {
      path: "balance",
      label: "باقیمانده",
    },
    {
      path: "overall_balance",
      label: "باقیمانده کل",
    },

    { path: "option" },
  ];

  return <Table data={data} columns={columns} query={query} />;
};

export default SectionSalaryList;
